import CryptoJS from 'crypto-js';

const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000'); // 16 bytes (32 hex characters) of zeros
const secretKey = CryptoJS.enc.Utf8.parse("et-secret-duty-fr".padEnd(16).substring(0, 16));

export const encryptPassword = (plainText) => {
  if (typeof CryptoJS === 'undefined') {
        console.error("CryptoJS library is not loaded");
        return null; // Or throw an error
    }
    let encrypted = CryptoJS.AES.encrypt(
        plainText,
        secretKey,
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }